import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './SummaryItem.css';

interface ISummaryItemProps {
  title: React.ReactNode;
}

export const SummaryItem: React.FC<React.PropsWithChildren<ISummaryItemProps>> = props => {
  const { title, children } = props;

  return (
    <div className={styles['summary_item']}>
      <UIText2 color="gray60_100">{title}</UIText2>

      <hr className={styles['dashed_line']} />

      <UIText2 color="gray60_100">{children}</UIText2>
    </div>
  );
};
